import EditParticipantModal from './EditParticipantModal';

export default EditParticipantModal;
